import clsx from 'clsx';

type Props = {
  status: string;
  label: string;
  size?: 'sm' | 'md';
};

const SpinnerIcon = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx('animate-spin', className)}
  >
    <path
      d="M7.99992 14.6666C7.07403 14.6666 6.20553 14.4934 5.39442 14.1471C4.58331 13.8009 3.87681 13.3268 3.27492 12.7249C2.67303 12.123 2.19897 11.4165 1.85275 10.6054C1.50642 9.79431 1.33325 8.92581 1.33325 7.99992C1.33325 7.07025 1.50642 6.20081 1.85275 5.39159C2.19897 4.58236 2.67303 3.87681 3.27492 3.27492C3.87681 2.67303 4.58331 2.19897 5.39442 1.85275C6.20553 1.50642 7.07403 1.33325 7.99992 1.33325C8.15181 1.33325 8.28236 1.38786 8.39159 1.49709C8.50081 1.60642 8.55542 1.73697 8.55542 1.88875C8.55542 2.04064 8.50081 2.1712 8.39159 2.28042C8.28236 2.38975 8.15181 2.44442 7.99992 2.44442C6.46292 2.44442 5.15275 2.98609 4.06942 4.06942C2.98609 5.15275 2.44442 6.46292 2.44442 7.99992C2.44442 9.53692 2.98609 10.8471 4.06942 11.9304C5.15275 13.0138 6.46292 13.5554 7.99992 13.5554C9.53692 13.5554 10.8471 13.0138 11.9304 11.9304C13.0138 10.8471 13.5554 9.53692 13.5554 7.99992C13.5554 7.84803 13.6101 7.71748 13.7194 7.60825C13.8286 7.49903 13.9592 7.44442 14.1111 7.44442C14.2629 7.44442 14.3934 7.49903 14.5028 7.60825C14.612 7.71748 14.6666 7.84803 14.6666 7.99992C14.6666 8.92581 14.4934 9.79431 14.1471 10.6054C13.8009 11.4165 13.3268 12.123 12.7249 12.7249C12.123 13.3268 11.4175 13.8009 10.6083 14.1471C9.79903 14.4934 8.92959 14.6666 7.99992 14.6666Z"
      fill="currentColor"
    />
  </svg>
);

export default function LinkedAccountsStatusChip({ status, label, size = 'md' }: Props) {
  return (
    <span
      className={clsx(
        'inline-flex items-center justify-center gap-1 rounded-full px-sm text-xs',
        status === 'success' && 'bg-tag-blue text-tag-blue',
        status === 'error' && 'bg-tag-red text-tag-red',
        status === 'ready' && 'bg-tag-yellow text-tag-yellow',
        status === 'running' && 'bg-tag-yellow text-tag-yellow',
        status === 'deleting' && 'bg-tag-gray',
        size === 'sm' && 'h-[20px]',
        size === 'md' && 'h-xl'
      )}
    >
      {label}
      {(status === 'running' || status === 'deleting') && (
        <SpinnerIcon className="size-4 opacity-50" />
      )}
    </span>
  );
}
